import React from "react";
import { Link } from "react-router-dom";
import SpokePage from "./SpokePage";
import { Star } from "./Star";
import { GULF_GUIDES, GULF_UPDATE, GUIDES_UPDATED, GUIDES_PUBLISHED } from "../../lib/gulfGuides";
import "./Editorial.css";

/* /candidates/guides — the Gulf market update + an index of the per-country guides.
   Gated for review while GUIDES_PUBLISHED is false (PageSEO marks it noindex). */
export default function GuidesHub() {
  return (
    <SpokePage
      audience="candidate"
      eyebrow="Working in the Gulf"
      title={<>Your guide to <em>working in the Gulf.</em></>}
      intro="Real, dated information for Kenyan workers — what the Gulf pays, who covers your visa and travel, and the rights that protect you. Updated regularly."
      next={{ label: "Submit your CV", to: "/candidates/apply" }}
    >
      {!GUIDES_PUBLISHED && (
        <section className="ed-band ed-band--sand ed-pad">
          <div className="ed-container">
            <p className="ed-stamp">Draft — figures pending final review before publishing.</p>
          </div>
        </section>
      )}

      {/* Gulf market update */}
      <section className="ed-band ed-band--cream ed-pad">
        <div className="ed-container">
          <header className="ed-opener">
            <div className="ed-opener__row">
              <span className="ed-eyebrow"><Star className="ed-eyebrow__star" /> Gulf market update</span>
            </div>
            <h2 className="ed-h2">{GULF_UPDATE.lede}</h2>
          </header>
          <p className="ed-lede">{GULF_UPDATE.intro}</p>
          <ul className="ed-list">
            {GULF_UPDATE.points.map((p, i) => <li key={i}>{p}</li>)}
          </ul>
          <p className="ed-stamp">Last updated {GUIDES_UPDATED}</p>
        </div>
      </section>

      {/* Country index */}
      <section className="ed-band ed-band--sand ed-pad">
        <div className="ed-container">
          <header className="ed-opener">
            <div className="ed-opener__row">
              <span className="ed-eyebrow"><Star className="ed-eyebrow__star" /> Guides by country</span>
            </div>
            <h2 className="ed-h2">Six countries, <em>one honest picture.</em></h2>
          </header>
          <div className="faq-list">
            {GULF_GUIDES.map((g) => (
              <Link
                key={g.slug}
                to={`/candidates/guides/${g.slug}`}
                className="faq-item"
                style={{ display: "block", textDecoration: "none", color: "inherit" }}
              >
                <h3 className="faq-q">{g.country} →</h3>
                <p className="faq-a">{g.lede}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </SpokePage>
  );
}
